import { TextField, MenuItem, Select, Grid } from '@mui/material';
import React, { useEffect, useState, FC, ChangeEvent } from 'react';

import { getCurrencies, getSalaryTimeSpans, ISalaryTimeSpan } from './utils/currency';

export interface ISalaryType {
  currency: string;
  value: number;
  timeSpan?: string;
}

interface ISalaryInput {
  initialValue?: ISalaryType;
  onInputChange(args: ISalaryType): void;
  addTimeField?: boolean;
}

const SalaryInput: FC<ISalaryInput> = ({ initialValue, onInputChange, addTimeField = false }) => {
  const [value, setValue] = useState<ISalaryType>({
    currency: 'USD',
    value: 0,
    timeSpan: 'PerAnnum',
  });

  const [currencies, setCurrencies] = useState<string[]>([]);

  const [timeSpan, setTimeSpan] = useState<ISalaryTimeSpan[]>([]);

  useEffect(() => {
    initialValue && setValue(initialValue);
    setCurrencies(getCurrencies());
    addTimeField && setTimeSpan(getSalaryTimeSpans());
  }, [addTimeField, initialValue]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>, field: string) => {
    const oldValue = { ...value };
    if (field === 'timeSpan') {
      oldValue['timeSpan'] = event.target.value;
    } else if (field === 'currency') {
      oldValue['currency'] = event.target.value;
    } else if (field === 'value') {
      oldValue['value'] = parseInt(event.target.value);
    }
    setValue({ ...oldValue });
    onInputChange(oldValue);
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={3}>
        <Select
          sx={{ height: '47px' }}
          fullWidth
          inputProps={{ 'aria-label': 'Without label' }}
          onChange={(e: ChangeEvent<HTMLInputElement>) => handleChange(e, 'currency')}
          value={value.currency}
        >
          {currencies.map((currency: string, index: number) => (
            <MenuItem key={index} value={currency}>
              {currency}
            </MenuItem>
          ))}
        </Select>
      </Grid>
      <Grid item xs={!addTimeField ? 10 : 5}>
        <TextField
          inputProps={{ style: { padding: '11.5px 14px' } }}
          fullWidth
          placeholder="Salary"
          onChange={(e: ChangeEvent<HTMLInputElement>) => handleChange(e, 'value')}
          variant="outlined"
          type="number"
          value={value.value}
          autoComplete="candidate_salary"
        />
      </Grid>
      {addTimeField && (
        <Grid item xs={4}>
          <Select
            sx={{ height: '47px' }}
            fullWidth
            inputProps={{ 'aria-label': 'Without label' }}
            onChange={(e: ChangeEvent<HTMLInputElement>) => handleChange(e, 'timeSpan')}
            value={value.timeSpan}
          >
            {timeSpan.map((span: ISalaryTimeSpan, index: number) => (
              <MenuItem key={index} value={span.value}>
                {span.label}
              </MenuItem>
            ))}
          </Select>
        </Grid>
      )}
    </Grid>
  );
};

export default SalaryInput;
